import $ from 'jquery'
window.jQuery = $;
window.$ = $;
export default $


// WEBPACK FOOTER //
// ./src/common/utils/jquery.js